import { FC, useCallback } from "react";
import { useTrackContext } from "../../../hooks/useTrackContext";
import { ImSpinner6 } from "react-icons/im";
import { REMOVE_CART_LINE } from "../../../graphqlQueries";
import { SHOPIFY_STOREFRONT_GRAPHQL_API, SHOPIFY_STOREFRONT_TOKEN } from "../../../config";
import { ICartItemHeadless } from "../../../types";
import { sortBySku } from "../../../helpers/utils";

const RemoveItemConfirmationPopup: FC = () => {
  const {
    productRenderedLocation,
    headlessCartRemoveItem,
    headlessCartInfo,
    dispatch,
    mainTrackSelection,
    miniTrackSection,
    juniorTrackSelection,
    battleKartSelection,
    vrSelection,
  } = useTrackContext();
  const { displayCartComfirmationPopup, shouldItemRemove, ItemId } = headlessCartRemoveItem;

  const handleClosePopup = () => {
    dispatch({
      type: "SET_HEADLESS_CART_REMOVE_ITEM",
      payload: {
        headlessCartRemoveItem: {
          ...headlessCartRemoveItem,
          displayCartComfirmationPopup: false,
        },
      },
    });
  };

  const handleRemoveItem = useCallback(() => {
    const graphqlEndpoint = SHOPIFY_STOREFRONT_GRAPHQL_API;
    const authToken = SHOPIFY_STOREFRONT_TOKEN;

    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": authToken,
    };

    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify({
        query: REMOVE_CART_LINE,
        variables: {
          cartId: headlessCartInfo.id,
          lineIds: ItemId,
        },
      }),
    };

    dispatch({
      type: "SET_HEADLESS_CART_REMOVE_ITEM",
      payload: {
        headlessCartRemoveItem: {
          ...headlessCartRemoveItem,
          shouldItemRemove: true,
        },
      },
    });

    fetch(graphqlEndpoint, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((cartItemHasRemoved) => {
        const cartLinesRemove = cartItemHasRemoved?.data?.cartLinesRemove;
        if (cartLinesRemove) {
          const cartItems = cartLinesRemove?.cart?.lines?.edges?.map((edge: { node: any }) => edge.node);
          dispatch({
            type: "SET_CARTITEMS_HEADLESS",
            payload: {
              headlessCart: [...cartItems] as ICartItemHeadless[],
            },
          });

          const cartVariantIds = cartItems ? cartItems.map((cartItem: any) => cartItem.merchandise?.id) : [];

          if (cartItems && cartItems.length > 0) {
            const remainingMainTrackItems = mainTrackSelection.variantsAndDate.selectedVariants.filter((item: any) => cartVariantIds.includes(item.variantsSelectedObject.id));
            const addSelectedMainTrackVariants = {
              ...mainTrackSelection.variantsAndDate,
              selectedSessionTime: mainTrackSelection.variantsAndDate.selectedSessionTime,
              selectedDate: mainTrackSelection.variantsAndDate.selectedDate,
              selectedVariants: sortBySku([...remainingMainTrackItems], "MAIN_TRACK"),
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT",
              payload: {
                variantsAndDate: addSelectedMainTrackVariants,
              },
            });
          } else {
            const addSelectedMainTrackVariants = {
              ...mainTrackSelection.variantsAndDate,
              selectedSessionTime: mainTrackSelection.variantsAndDate.selectedSessionTime,
              selectedDate: mainTrackSelection.variantsAndDate.selectedDate,
              selectedVariants: [],
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT",
              payload: {
                variantsAndDate: addSelectedMainTrackVariants,
              },
            });
          }

          if (cartItems && cartItems.length > 0) {
            const remainingMiniTrackItems = miniTrackSection.variantsAndDate.selectedVariants.filter((item: any) => cartVariantIds.includes(item.variantsSelectedObject.id));
            const addSelectedMiniTrackVariants = {
              ...miniTrackSection.variantsAndDate,
              selectedSessionTime: miniTrackSection.variantsAndDate.selectedSessionTime,
              selectedDate: miniTrackSection.variantsAndDate.selectedDate,
              selectedVariants: sortBySku([...remainingMiniTrackItems], "MINI_TRACK"),
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_MINI_TRACK",
              payload: {
                variantsAndDate: addSelectedMiniTrackVariants,
              },
            });
          } else {
            const addSelectedMiniTrackVariants = {
              ...miniTrackSection.variantsAndDate,
              selectedSessionTime: miniTrackSection.variantsAndDate.selectedSessionTime,
              selectedDate: miniTrackSection.variantsAndDate.selectedDate,
              selectedVariants: [],
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_MINI_TRACK",
              payload: {
                variantsAndDate: addSelectedMiniTrackVariants,
              },
            });
          }

          if (cartItems && cartItems.length > 0) {
            const remainingJuniorTrackItems = juniorTrackSelection.variantsAndDate.selectedVariants.filter((item: any) => cartVariantIds.includes(item.variantsSelectedObject.id));
            const addSelectedJuniorTrackVariants = {
              ...juniorTrackSelection.variantsAndDate,
              selectedSessionTime: juniorTrackSelection.variantsAndDate.selectedSessionTime,
              selectedDate: juniorTrackSelection.variantsAndDate.selectedDate,
              selectedVariants: sortBySku([...remainingJuniorTrackItems], "JUNIOR_TRACK"),
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_JUNIOR_TRACK",
              payload: {
                variantsAndDate: addSelectedJuniorTrackVariants,
              },
            });
          } else {
            const addSelectedJuniorTrackVariants = {
              ...juniorTrackSelection.variantsAndDate,
              selectedSessionTime: juniorTrackSelection.variantsAndDate.selectedSessionTime,
              selectedDate: juniorTrackSelection.variantsAndDate.selectedDate,
              selectedVariants: [],
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_JUNIOR_TRACK",
              payload: {
                variantsAndDate: addSelectedJuniorTrackVariants,
              },
            });
          }

          if (cartItems && cartItems.length > 0) {
            const remainingVRItems = vrSelection.variantsAndDate.selectedVariants.filter((item: any) => cartVariantIds.includes(item.variantsSelectedObject.id));
            const addSelectedVRVariants = {
              ...vrSelection.variantsAndDate,
              selectedSessionTime: vrSelection.variantsAndDate.selectedSessionTime,
              selectedDate: vrSelection.variantsAndDate.selectedDate,
              selectedVariants: sortBySku([...remainingVRItems], "VIRTUAL_REALITY"),
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_VIRTUAL_REALITY",
              payload: {
                variantsAndDate: addSelectedVRVariants,
              },
            });
          } else {
            const addSelectedVRVariants = {
              ...vrSelection.variantsAndDate,
              selectedSessionTime: vrSelection.variantsAndDate.selectedSessionTime,
              selectedDate: vrSelection.variantsAndDate.selectedDate,
              selectedVariants: [],
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_VIRTUAL_REALITY",
              payload: {
                variantsAndDate: addSelectedVRVariants,
              },
            });
          }

          if (cartItems && cartItems.length > 0) {
            const remainingBattleKartItems = battleKartSelection.variantsAndDate.selectedVariants.filter((item: any) => cartVariantIds.includes(item.variantsSelectedObject.id));
            const addSelectedBattleKartVariants = {
              ...battleKartSelection.variantsAndDate,
              selectedSessionTime: battleKartSelection.variantsAndDate.selectedSessionTime,
              selectedDate: battleKartSelection.variantsAndDate.selectedDate,
              selectedVariants: sortBySku([...remainingBattleKartItems], "BATTLE_KART_TRACK"),
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_BATTLE_KART_TRACK",
              payload: {
                variantsAndDate: addSelectedBattleKartVariants,
              },
            });
          } else {
            const addSelectedBattleKartVariants = {
              ...battleKartSelection.variantsAndDate,
              selectedSessionTime: battleKartSelection.variantsAndDate.selectedSessionTime,
              selectedDate: battleKartSelection.variantsAndDate.selectedDate,
              selectedVariants: [],
            };
            dispatch({
              type: "SET_DATE_AND_VARIANT_BATTLE_KART_TRACK",
              payload: {
                variantsAndDate: addSelectedBattleKartVariants,
              },
            });
          }

          const cartTotalAmount = cartLinesRemove?.cart?.cost?.totalAmount?.amount;
          dispatch({
            type: "SET_HEADLESS_CART_TOTAL_AMOUNT",
            payload: {
              headlessCartTotalAmount: cartTotalAmount,
            },
          });

          dispatch({
            type: "SET_HEADLESS_CART_REMOVE_ITEM",
            payload: {
              headlessCartRemoveItem: {
                ...headlessCartRemoveItem,
                shouldItemRemove: false,
                displayCartComfirmationPopup: false,
              },
            },
          });
        } else {
          dispatch({
            type: "SET_HEADLESS_CART_REMOVE_ITEM",
            payload: {
              headlessCartRemoveItem: {
                ...headlessCartRemoveItem,
                shouldItemRemove: false,
                displayCartComfirmationPopup: false,
              },
            },
          });
          console.error("handleRemoveItem Cart data is missing in the GraphQL response.", cartItemHasRemoved);
        }
      })
      .catch((error) => {
        dispatch({
          type: "SET_HEADLESS_CART_REMOVE_ITEM",
          payload: {
            headlessCartRemoveItem: {
              ...headlessCartRemoveItem,
              shouldItemRemove: false,
              displayCartComfirmationPopup: false,
            },
          },
        });
        console.error("GraphQL request failed:", error);
      })
      .finally(() => {
        dispatch({
          type: "SET_HEADLESS_CART_REMOVE_ITEM",
          payload: {
            headlessCartRemoveItem: {
              ...headlessCartRemoveItem,
              shouldItemRemove: false,
              displayCartComfirmationPopup: false,
            },
          },
        });
      });
  }, [
    ItemId,
    battleKartSelection.variantsAndDate,
    dispatch,
    headlessCartInfo.id,
    headlessCartRemoveItem,
    juniorTrackSelection.variantsAndDate,
    mainTrackSelection.variantsAndDate,
    miniTrackSection.variantsAndDate,
    vrSelection.variantsAndDate,
  ]);

  return (
    <>
      {displayCartComfirmationPopup && productRenderedLocation === "external" && (
        <>
          <div className="tw-fixed tw-z-50 tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50 tw-px-[10px] lg:tw-px-0">
            <div className="tw-bg-[#393B41] lg:tw-max-w-[792px] tw-w-full tw-mx-auto tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100">
              <div className="tw-pb-[46px] lg:tw-pb-[98px]">
                <div className="tw-flex tw-justify-end tw-p-[19px]">
                  <button className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none" onClick={() => handleClosePopup()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M19.1183 1.05664L1.48218 18.6928" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M19.124 18.7039L1.47314 1.04932" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
                {shouldItemRemove ? (
                  <>
                    <ImSpinner6 className="tw-flex tw-justify-center tw-text-white tw-mx-auto tw-h-[70px] tw-w-[70px] tw-animate-spin tw-transition tw-duration-300 tw-ease-in-out" />
                  </>
                ) : (
                  <>
                    <p className="tw-text-white tw-text-[24px] lg:tw-text-[30px] tw-font-[500] tw-text-center tw-mt-12px tw-px-[19px] lg:tw-px-[100px]">
                      Are you sure you want to remove this session from your booking?
                    </p>
                    <div className="tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-mt-[14px]">
                      <button
                        onClick={() => handleClosePopup()}
                        className="tw-flex tw-items-center tw-justify-center tw-text-center tw-text-[#9D62FE] tw-py-[8px] tw-px-[40px] tw-border-[1px] tw-border-[#9D62FE] tw-rounded-full tw-cursor-pointer tw-w-fit tw-text-[18px] tw-font-[700]"
                      >
                        No
                      </button>
                      <button
                        onClick={() => handleRemoveItem()}
                        className="tw-flex tw-items-center tw-justify-center tw-text-center tw-text-white tw-py-[10px] tw-px-[40px] bg-gradient-2 tw-rounded-full tw-cursor-pointer tw-w-fit tw-text-[18px] tw-font-[700]"
                      >
                        Yes
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RemoveItemConfirmationPopup;
